<template>
    <div class="main">
        <c-panel title="Dashboard da Biblioteca" titleIcon="fas fa-chart-bar">
            <dashboard></dashboard>
        </c-panel>
    </div>
</template>
<script>
import dashboard from "./dashboard"

export default {
    components:{ dashboard }
}
</script>
